export default class {
  /**
   * Fetch doesn't throw error on non-2xx response, so this method wraps it
   * in a Promise, which does throw error on non-2xx response.
   * @param {string} url
   * @param {object} data
   * @param {string} method
   * @param {boolean} isFormData
   * @param {object} headers
   */
  static apiRequest(url = ``, data = {}, method = "POST", isFormData = false, headers = {}) {
    const options = {
      method: method,
      mode: "cors",
      cache: "no-cache",
      credentials: "include",
      redirect: "follow",
      referrer: "no-referrer",
      body: method === "GET" || method === "HEAD" ?
        null :
        isFormData ?
          data :
          JSON.stringify(data)
    };

    if (!isFormData) {
      options.headers = {
        "Content-Type": "application/json",
        ...headers,
      };
    }

    return new Promise((resolve, reject) => {
      fetch(url, options)
        .then(this.parseFetchResponse)
        .then(response => {
          if (response.status === 401) {
            this.unauth();
          }

          if (response.ok) {
            return resolve(response.json);
          }

          return response.hasOwnProperty('json') && response.json.hasOwnProperty('message') ?
            reject(response.json.message) :
            reject("Invalid response");
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  static parseFetchResponse(response) {
    return new Promise(resolve =>
      response.json()
        .then(json => resolve({
          status: response.status,
          ok: response.ok,
          json,
        }))
        .catch(e => resolve({
          status: response.status,
          ok: response.ok,
          json: ""
        })) // Couldn't parse response, probably empty
    );
  }

  static apiUpload(url = ``, data = {}) {
    return fetch(url, {
      method: "POST",
      mode: "cors",
      cache: "no-cache",
      credentials: "include",
      redirect: "follow",
      referrer: "no-referrer",
      body: data
    }).then(response => {
      if (response.status === 401) {
        this.unauth();
      }
      if (response.status !== 200) throw new Error();
      return response.json();
    });
  }

  static unauth() {
    window.location.replace(`${window.location.origin}/login`);
  }
}
